<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import moment from "moment";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
/**
 * Products component
 */
export default {
  page: {
    title: "Product",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      apiUrl: process.env.VUE_APP_URL,
      logoUrl: (process.env.BASE_URL || "/") + "logo.jpeg",
      userT: this.$store.state.authfack.user,
      formPro: {
        direccionp: "",
        empleado: "",
        nit_proveedor: "",
        no_factura: "",
        fecha_compra: "",
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      detallecompra: [],
      title: "Compras",
      items: [
        {
          text: "Compras",
          href: "/",
        },
        {
          text: "Compras",
          active: true,
        },
      ],
    };
  },
  mounted() {
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
    this.detalle();
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // FUNCIONES AUXILIARES
    money(value) {
      return (
        "Q " +
        parseFloat(value)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    showDate(date) {
      return moment(date).locale("es").utc().format("MMM Do YYYY");
    },
    detalle() {
      axios
        .get(
          process.env.VUE_APP_URL +
            "compras/view_compra?id=" +
            this.$route.params.id,
          {
            headers: { "x-token": this.userT.token },
          }
        )
        .then((response) => {
          this.detallecompra = response.data.compra.detalle_compras;
          this.formPro.total = response.data.compra.total_c;
          this.formPro.direccionp =
            response.data.compra.proveedore.direccion_proveedor;
          this.formPro.fecha_compra = this.showDate(
            response.data.compra.fecha_compra
          );
          this.formPro.no_factura = response.data.compra.no_factura_c;
          this.formPro.proveedor =
            response.data.compra.proveedore.company_proveedor;
          this.formPro.nit_proveedo =
            response.data.compra.proveedore.nit_proveedor;
          this.formPro.empleado =
            response.data.compra.user.empleado.persona.nombre_persona +
            " " +
            response.data.compra.user.empleado.persona.apellido_persona;

          console.log(response.data.compra);
        });
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" class="d-print-none" />

    <!-- Botones -->
    <div class="row mt-4 d-print-none">
      <div class="col">
        <router-link
          :to="{ name: 'compras' }"
          class="btn text-muted d-none d-sm-inline-block btn-link"
        >
          <i class="mdi mdi-arrow-left me-1"></i>REGRESAR
        </router-link>
      </div>
      <div class="col">
        <div class="float-end">
          <a
            href="javascript:window.print()"
            class="btn btn-primary w-md waves-effect waves-light me-1"
          ><i class="fa fa-print"></i>&nbsp;&nbsp;IMPRIMIR</a>
        </div>
      </div>
    </div>

    <!-- Orden de compra -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body doc">
            <!-- Header corporativo -->
            <div class="doc-header">
              <div class="doc-brand">
                <img :src="logoUrl" alt="Logo" class="doc-logo" />
                <div>
                  <div class="doc-name">Repuestos Ariel GT</div>
                  <div class="doc-tag">Comapa, Jutiapa</div>
                </div>
              </div>
              <div class="doc-meta">
                <div class="doc-badge">ORDEN DE COMPRA</div>
                <div class="doc-no">No. {{ formPro.no_factura }}</div>
                <div class="doc-date">Fecha: {{ formPro.fecha_compra }}</div>
              </div>
            </div>

            <!-- Proveedor / Comprador -->
            <div class="doc-grid">
              <div class="doc-box">
                <div class="doc-box-title">Proveedor</div>
                <div class="doc-box-name">{{ formPro.proveedor }}</div>
                <div class="doc-box-line"><span>NIT:</span> {{ formPro.nit_proveedo }}</div>
                <div class="doc-box-line"><span>Dirección:</span> {{ formPro.direccionp }}</div>
              </div>
              <div class="doc-box">
                <div class="doc-box-title">Comprador</div>
                <div class="doc-box-name">{{ formPro.empleado }}</div>
                <div class="doc-box-line"><span>Empresa:</span> Repuestos Ariel GT</div>
              </div>
            </div>

            <div class="doc-section">Resumen de orden</div>
            <table class="doc-table">
              <thead>
                <tr>
                  <th class="c" style="width: 50px">No.</th>
                  <th>Producto</th>
                  <th class="c">Cantidad</th>
                  <th class="r">Precio</th>
                  <th class="r">Subtotal</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in detallecompra" v-bind:key="idx">
                  <td class="c">{{ idx + 1 }}</td>
                  <td>
                    {{ item.stock.producto.nombre_producto }}
                    {{ item.stock.presentacione.nombre_presentacion }}
                  </td>
                  <td class="c">{{ item.cantidad_compra }}</td>
                  <td class="r">{{ money(item.stock.precio_compra_stock) }}</td>
                  <td class="r">{{ money(item.subtotal_compra) }}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="4" class="r">Total</td>
                  <td class="r">{{ money(formPro.total) }}</td>
                </tr>
              </tfoot>
            </table>

            <div class="doc-footer">Repuestos Ariel GT · Orden de compra</div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.doc { color: #2b2f3a; font-size: 13px; }

.doc-header {
  display: flex; align-items: center; justify-content: space-between;
  border-bottom: 4px solid #1b2a4e; padding-bottom: 16px; margin-bottom: 18px;
}
.doc-brand { display: flex; align-items: center; gap: 16px; }
.doc-logo { height: 74px; width: auto; object-fit: contain; border-radius: 8px; }
.doc-name { font-size: 23px; font-weight: 800; color: #1b2a4e; }
.doc-tag { font-size: 12px; color: #6b7280; }
.doc-meta { text-align: right; }
.doc-badge {
  background: #1b2a4e; color: #fff; font-weight: 700; font-size: 13px;
  padding: 6px 14px; border-radius: 4px; letter-spacing: 1px; display: inline-block;
}
.doc-no { font-size: 18px; font-weight: 800; color: #c5a253; margin-top: 6px; }
.doc-date { font-size: 12px; color: #6b7280; }

.doc-grid { display: flex; gap: 14px; margin-bottom: 16px; }
.doc-box {
  flex: 1; background: #f7f9fc; border: 1px solid #e7e9ef;
  border-radius: 8px; padding: 12px 16px;
}
.doc-box-title { font-size: 10px; color: #8a909c; text-transform: uppercase; letter-spacing: .5px; margin-bottom: 4px; }
.doc-box-name { font-size: 15px; font-weight: 700; color: #1b2a4e; }
.doc-box-line { font-size: 12px; color: #4b5563; margin-top: 2px; }
.doc-box-line span { color: #8a909c; }

.doc-section {
  font-size: 14px; font-weight: 700; color: #1b2a4e;
  margin: 10px 0 8px; padding-left: 10px; border-left: 4px solid #c5a253;
}

.doc-table { width: 100%; border-collapse: collapse; }
.doc-table thead th {
  background: #1b2a4e; color: #fff; font-size: 11px; font-weight: 600;
  text-transform: uppercase; padding: 9px 10px; text-align: left;
}
.doc-table tbody td { padding: 8px 10px; border-bottom: 1px solid #eef0f4; font-size: 12px; }
.doc-table tbody tr:nth-child(even) { background: #f9fafc; }
.doc-table tfoot td {
  padding: 10px; font-weight: 700; color: #1b2a4e; background: #eef1f7; font-size: 15px;
}
.doc-table .r { text-align: right; }
.doc-table .c { text-align: center; }

.doc-footer {
  margin-top: 26px; text-align: center; color: #8a909c; font-size: 11px;
  border-top: 1px solid #e7e9ef; padding-top: 10px;
}

@media print {
  .doc, .doc * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}
</style>
